import React, { useRef } from "react";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useForm, Controller, useWatch } from "react-hook-form";
import Axios from "axios";
import { useState, useEffect } from 'react';
import defaultimg from "../assets/images/icons8-circled-user-male-skin-type-3-100.png"
import { Link, useLocation,useNavigate} from 'react-router-dom';
import { GetCourseInfo, GetCandidateById, GetJobRoles, GetCountries, GetListOfVendorsByEmployeeID, ReplicateBenchCandidatesProfileAPI,GetDocumentTypes, defaultfilebaseurl, GetJobPosts, usStates, usStateCities,IndiaStates,IndiaStateCities, SaveCandidateRecordedAudio } from "../apiconstants/constants";
import Swal from 'sweetalert2';
import LoadingSpinner from "../helpers/loadingspinner";
import "../consultant/addeditcandidate/cadidatestyles.css"
import ConsultantLayout from "../commonlayouts/consultantlayout";
import CandidateLayout from "../commonlayouts/candidatelayout";
import { useCountry } from "../contexts/countrycodecontext.js";
import Modal from 'react-bootstrap/Modal';
import mammoth from "mammoth";
import Select from 'react-select';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const sanitize = (value) => {
  return value !== null && value != undefined && value !== "undefined" && value !== "null" ? value : "";
};
const sanitize1 = (value) => {
  if (value === null || value === undefined || value === "undefined" || value === "null" || value === "") {
    return "";
  }

  const cleaned = String(value).replace(/[^0-9]/g, "");

  const num = Number(cleaned);
  return isNaN(num) ? "" : num;
};
const ReplicateBenchCandidatesProfile = () => {
  let query = useQuery();
  const fileInputRef = useRef(null);
const navigate=useNavigate();

  var queryguid = query.get("guid");
  const { register, handleSubmit, formState, control,watch, setValue,getValues } = useForm();
  const { errors } = formState
  const { isSubmitting } = formState;
  const [isDisabled, setIsDisabled] = useState(false);
  const [Courses, SetCourses] = useState([{}]);
  const [file, setFile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [filepath, setFilepath] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [photoURL, setPhotoURL] = useState();
  const [imgfilepath, setimgFilepath] = useState();
  const [visaCopy, setVisaCopy] = useState();
  const [visaCopyName, setVisaCopyName] = useState(null);
  const [drivingLicence, setDrivingLicence] = useState();
  const [drivingLicenceName, setDrivingLicenceName] = useState(null);
  const [maskedResumeCopy, setMaskedResumeCopy] = useState();
  const[maskedResumeName,setMaskedResumeName] = useState(null);
  const [jobRoles, SetJobRoles] = useState([{}]);
  const [Countries,SetCountries]=useState([{}]);
  const [workmode, setWorkMode] = useState([
    { statusID: "1", statusName: "Work from Home" },
    { statusID: "2", statusName: "Work from Office" },
    { statusID: "3", statusName: "Hybrid" }])
  const [isActiveStatus, setActiveStatus] = useState()
  const [candidatesID, setCandidatesID] = useState();
  const [fileError, setFileError] = useState('');
  const [vendorData, setVendorData] = useState([]);
  const {selectedCountry} = useCountry();
     const [documents,SetDocuments] =useState([{}]);
      const [uploadedFiles, setUploadedFiles] = useState({});
      const [showModal, setShowModal] = useState(false);
      const [selectedDocType, setSelectedDocType] = useState(null);
          const [candidateDetails, setCandidateDetails] = useState(null);
          const [showAssessmentModal, setShowAssessmentModal] = useState(false);
            const [assessmentMode, setAssessmentMode] = useState(""); // "link" or "file"
            const [assessmentFile, setAssessmentFile] = useState(null);
            const [audioFile, setAudioFile] = useState("");  
            const [audioValue, setAudioValue] = useState("");  
            const token = localStorage.getItem("jwtToken");
     const [skills, setSkills] = useState([
        { Skill: "", YearsOfExp: "", Rating: "" },
      ]);
    const documentLabels = {
      FileUrl: "Resume",
      VisaCopyUrl: "VisaCopy",
      DrivingLicenceUrl: "DrivingLicence",
      PassportURL: "Passport",
      I94File: "I-94",
      RTR_PDFDoc:"RTR_PDF",
      Resume_Insights_Pdfdoc:"Resume_Insights_Pdf",
      OthersDoc:"Others"
    };
    const [showModal1, setShowModal1] = useState(false);
const [modalContent, setModalContent] = useState({
  title: '',
  url: '',
});
const workAuthOptions = [
  { value: "", label: "Current Visa" },

  // Citizenship / Permanent
  { value: "US Citizen", label: "US Citizen" },
  { value: "Green Card", label: "Green Card" },
  { value: "GC EAD", label: "GC EAD" },
  // H Visa
  { value: "H1B", label: "H1B" },
  { value: "H4 EAD", label: "H4 EAD" },

  // L Visa
  { value: "L1", label: "L1" },
  { value: "L2 EAD", label: "L2 EAD" },

  // F Visa
  { value: "OPT", label: "OPT (F1)" },
  { value: "OPT EAD", label: "OPT EAD" },
  { value: "CPT", label: "CPT (F1)" },

  // Trade / NAFTA
  { value: "TN Visa", label: "TN Visa" },
  { value: "E3", label: "E3 (Australia)" },

  // Employment Authorization
  { value: "EAD", label: "EAD (General Work Authorization)" },
  { value: "Asylum EAD", label: "Asylum EAD" },
  { value: "Refugee EAD", label: "Refugee EAD" },
  // Fallback
  { value: "Other", label: "Other" },
];

// Entry Visa options
const entryVisaOptions = [
  { value: "", label: "First Entry Visa" },
  { value: "B1/B2", label: "B1/B2 (Visitor)" },
  { value: "F1", label: "F1 (Student)" },
  { value: "H1B", label: "H1B" },
  { value: "H4", label: "H4" },
  { value: "J1", label: "J1 (Exchange Visitor)" },
  { value: "L1", label: "L1" },
  { value: "L2", label: "L2" },
  { value: "Other", label: "Other" },
];

// Alphabetical sort (ignores first "placeholder" option)
const sortOptions = (options) => {
  const [first, ...rest] = options;
  return [first, ...rest.sort((a, b) => a.label.localeCompare(b.label))];
};

       const [candidateType,setCandidateType] = useState([
        {candidateTypeID:"Internal Bench",typeName:"Internal Bench"},
        {candidateTypeID:"C2C",typeName:"C2C"},
        {candidateTypeID:"W2",typeName:"W2"},
      {candidateTypeID:"1099",typeName:"1099"}]);
          const [jobPosts, setJobPosts] = useState([]);
          const [initialJobTitleID, setInitialJobTitleID] = useState(null);
    
      const selectedJobRole = watch("JobRole");
  const selectedVendorGuid = watch("VendorGuid");
          useEffect(() => {
        if (selectedJobRole && selectedVendorGuid) {
          fetchJobPosts(parseInt(selectedJobRole), selectedVendorGuid);
        } else {
          setJobPosts([]); // clear if either is not selected
        }
      }, [selectedJobRole, selectedVendorGuid]);
      
      const fetchJobPosts = async (jobRoleId, vendorGuid) => {
        setIsLoading(true);
        try {
          const response = await Axios.get(`${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          // Filter based on selected Job Role and Vendor (client)
          const filteredPosts = response.data.filter((post) =>
            post.jobRoleID == jobRoleId && post.vGuid == vendorGuid&&
           post.status=="Active"
          );
              console.log(filteredPosts)
      
          setJobPosts(filteredPosts);
          if (initialJobTitleID && filteredPosts.length > 0) {
      const matchedPost = filteredPosts.find(post => post.jobPostID == parseInt(initialJobTitleID));
      console.log("279",matchedPost,initialJobTitleID)
      if (matchedPost) {
        const jobPostObject = {
          value: matchedPost.jobPostID,
          label: `${matchedPost.title} - ${matchedPost.clientName}`,
          jobDescription: matchedPost.jobDescription,
        };
        setValue("jobPost", jobPostObject);
      }
    }
    
        } catch (error) {
          console.error("Error fetching job posts", error);
        } finally {
          setIsLoading(false);
        }
      };

        const [years, setYears] = useState("");
        const [months, setMonths] = useState("");
        const handleExperienceChange = (y, m) => {
          setYears(y);
          setMonths(m);
          const expText = `${y ? y + " Years" : ""} ${m ? m + " Months" : ""}`.trim();
          setValue("experience", expText); // store combined value in RHF
        };

    const [workAuth, setWorkAuth] = useState("");
    const [entryDate, setEntryDate] = useState("");
    const [entryVisa, setEntryVisa] = useState("");
    
   const handleWorkAuthChange = (auth, date, visa) => { 
  setWorkAuth(auth);
  setEntryDate(date);
  setEntryVisa(visa);

  let text = auth || "";

  const parts = [];
  if (visa) parts.push(visa);
  if (date) parts.push(`on ${date}`);

  if (parts.length > 0) {
    text = `${auth} (First US Entry: ${parts.join(" ")})`;
  }

  setValue("WorkAuthorizationandValidity", text);
};


    const handleShowModal = (docType) => {
      setSelectedDocType(docType);
      setShowModal(true);
    };
    
    const handleCloseModal = () => {
      setShowModal(false);
      setSelectedDocType(null);
    };
  const handleShowModal1 = async (docTypeKey, file) => {
  if (!file) return;

  let fileName = "";
  let blobUrl = "";

  if (file instanceof File) {
    fileName = file.name.toLowerCase();
    blobUrl = URL.createObjectURL(file);
  } else if (typeof file === "string") {
    fileName = file.split("/").pop().toLowerCase();
    blobUrl = file;
  } else {
    console.error("Unknown file type");
    return;
  }

 if (fileName.endsWith(".docx")) {
  if (file instanceof File) {
    try {
      const arrayBuffer = await file.arrayBuffer();
      const { value } = await mammoth.convertToHtml({ arrayBuffer });
      setModalContent({
        title: documentLabels[docTypeKey] || docTypeKey,
        html: value,
        url: null,
        file: file,
      });
    } catch (error) {
      console.error("DOCX preview error", error);
      setModalContent({
        title: documentLabels[docTypeKey] || docTypeKey,
        html: "<p>Failed to render DOCX preview.</p>",
        url: null,
        file: file,
      });
    }
  } else if (typeof file === "string") {
    // ✅ Set the URL so Office viewer iframe can use it
    setModalContent({
      title: documentLabels[docTypeKey] || docTypeKey,
      html: null,
      url: file, // ✅ not null anymore
      file: null,
    });
  } else {
    console.error("Invalid DOCX file type");
    setModalContent({
      title: documentLabels[docTypeKey] || docTypeKey,
      html: "<p>Cannot preview this DOCX file.</p>",
      url: null,
      file: null,
    });
  }
}
else {
  setModalContent({
    title: documentLabels[docTypeKey] || docTypeKey,
    html: null,
    url: file,
    file: null,
  });
}

  setShowModal1(true);
};

const handleCloseModal1 = () => {
  setShowModal1(false);
};
const renderAttachment = (url, file, html) => {
  console.log("url",url)
  if (html) {
    // DOCX preview with mammoth
    return (
      <div
        style={{ maxHeight: "500px", overflowY: "auto" }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  const name =
    (file && file.name?.toLowerCase()) ||
    (url && url.split("/").pop()?.toLowerCase()) ||
    "";

  if (!url) {
    return <div>File not found.</div>;
  }

  if (name.endsWith(".pdf")) {
    return (
      <iframe
        src={url}
        style={{ width: "100%", height: "500px", border: "none" }}
        title="PDF Preview"
      />
    );
  } else if (
    name.endsWith(".jpg") ||
    name.endsWith(".jpeg") ||
    name.endsWith(".png")
  ) {
    return <img src={url} alt="preview" style={{ maxWidth: "100%" }} />;
  } else if (name.endsWith(".docx")) {
    console.log("183")
    if (url?.startsWith("https")) {
      console.log("184")
      // use Google Docs Viewer for server URL
      return (
      <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`} title="Attachment" style={{ width: '100%', height: '500px' }} />

      );
    }  else if (name.endsWith(".html") ||
    name.endsWith(".htm")) {
            return (
                <iframe
                    src={url}
                    title="HTML Attachment"
                    style={{ width: '100%', height: '500px', border: 'none' }}
                />
            );
        } else {
      // local blob DOCX fallback
      return (
        <div>
          <p>
            DOCX preview is not supported for local file.{" "}
            <a href={url} target="_blank" rel="noreferrer">
              Download
            </a>
          </p>
        </div>
      );
    }
  } else {
    return (
      <div>
        <p>
          Preview is not supported for this file type.{" "}
          <a href={url} target="_blank" rel="noreferrer">
            Download
          </a>
        </p>
      </div>
    );
  }
};

const handleRemoveFile = (docTypeKey) => {
  setUploadedFiles(prev => ({
    ...prev,
    [docTypeKey]: null  // mark as removed
  }));
};

  let Guid="";

  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid")
  const email = localStorage.getItem("email")
  const roleID = localStorage.getItem("roleID")
  
  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }

  
const GetVendorsList = async() => {
  setIsLoading(true);

  const GetapiUrl = GetListOfVendorsByEmployeeID.APIURL + `?UserGuid=${Guid}&CountryID=${selectedCountry}`;

 await Axios.get(GetapiUrl)
    .then((result) => {
      setIsLoading(false);

      setVendorData(result.data);
    }).catch((error) => {
      console.log("Error" + error);
    });
};

  const fetchcountries= async()=>
    {
      const GetapiUrl=GetCountries.APIURL;
      const fetchJSON = async () => {
        const response = await fetch(GetapiUrl,
          { headers: {   Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",    
           } }
        );
        let json = await response.json();
        SetCountries(json);
      }
      fetchJSON();
  }

  const extractDriveFileId = (url) => {
  if (!url) return null;
  const match = url.match(/\/d\/([^/]+)\//);
  return match ? match[1] : null;
};

  const GetCandidateDetailsById = async () => {
    const GetapiUrl = GetCandidateById.APIURL;
    const fliterdata = {
      "guid": queryguid
    };
    await  Axios.post(GetapiUrl, fliterdata)
      .then((result) => {
        setIsLoading(false)
        setCandidateDetails(result.data);
        setUploadedFiles({
  FileUrl: result.data.fileUrl || null,
  VisaCopyUrl: result.data.visaCopyUrl || null,
  DrivingLicenceUrl: result.data.drivingLicenceUrl || null,
  PassportURL: result.data.passportURL || null,
  I94File: result.data.i94File || null,
  RTR_PDFDoc: result.data.rtR_PDFDoc || null,
  Resume_Insights_Pdfdoc: result.data.resume_Insights_Pdfdoc || null,
  OthersDoc: result.data.othersDoc || null
});
const addr = result.data?.address;

if (addr && addr.includes(" - ")) {
  // expected format: "State - Code - City"
  const parts = addr.split(" - ");
  const stateValue = `${parts[0].trim()} - ${parts[1]?.trim() || ""}`;
  const cityValue = parts[2]?.trim() || "";

  setSelectedState(stateValue);

  const cityList =
    selectedCountry == 1
      ? IndiaStateCities[stateValue] || []
      : usStateCities[stateValue] || [];

  setCities(cityList);

  if (cityList.includes(cityValue)) {
    setSelectedCity(cityValue);
  } else {
    setSelectedCity(""); // reset if city not found
  }
} else {
  // address missing or not in expected format → reset
  setSelectedState("");
  setSelectedCity("");
  setCities([]);
}
        setValue("fullName",  sanitize(result.data?.fullName))
        setValue("email",  sanitize(result.data?.email))
        setValue("mobileNumber",  sanitize(result.data?.mobileNumber))
        setValue("gender",  sanitize(result.data?.gender))
        setValue("dob",  sanitize(result.data?.dob))
        setValue("address",  sanitize(result.data?.address))
        setValue("isActive", result.data?.isActive.toString())
        setActiveStatus(result.data?.isActive.toString())
        setValue("photoURL", result.data.photoURL)
        setimgFilepath(result.data.photoURL)
        setValue("photo", result.data?.photo)
        setPhotoURL(result.data?.photo)
        setValue("maritalStatus",  sanitize(result.data?.maritalStatus))
        setValue("QualificationID", sanitize( result.data?.qualificationID))
        setValue("HighestEducation", result.data?.highestEducation)
        setValue("jobTitleID", sanitize( result.data?.jobTitleID))
        setInitialJobTitleID(result.data?.jobTitleID);
        setValue("CandidateType", sanitize( result.data?.candidateType))
        setValue("technicalSkill",  sanitize(result.data?.technicalSkill))
        setValue("experience",  sanitize(result.data?.experience))
        setValue("currentRole", result.data?.currentRole)
        setValue("preferLocation",  sanitize(result.data?.preferLocation))
        setValue("workMode",  sanitize(result.data?.workMode))
        setValue("ProfileSummery",  sanitize(result.data?.profileSummery))
        const driveFileId = extractDriveFileId(result.data.customAssessmentLink);
    setAudioFile(sanitize(result.data.customAssessmentLink)); // full link (for display)                    // just ID (for API)
   setAudioValue(driveFileId);                      // keep only ID for API
    setValue("customAssessmentLink", sanitize(result.data.customAssessmentLink)); // 👈 keep link visible in form
    
             const parsed = JSON.parse(result.data?.skillMetrics);
        if (Array.isArray(parsed)) {
          setSkills(parsed);
          setValue("SkillMetrics", JSON.stringify(parsed));
        }

         const exp = sanitize(result.data.experience || "");

const yearMatch = exp.match(/(\d+)\s*year/i);
const monthMatch = exp.match(/(\d+)\s*month/i);

const y = yearMatch ? yearMatch[1] : "";
const m = monthMatch ? monthMatch[1] : "";

handleExperienceChange(y, m);
  const stored = sanitize(result.data.workAuthorizationandValidity);

// Extract current visa (before the first "(")
const authMatch = stored.match(/^[^(]+/);
const auth = authMatch ? authMatch[0].trim() : "";

// Extract entry visa type (only if it's before "on" or alone)
let entryVisa = "";
const visaMatch = stored.match(/First US Entry:\s*([A-Za-z0-9/]+)(?:\s|$)/);
if (visaMatch && visaMatch[1] !== "on") {
  entryVisa = visaMatch[1].trim();
}

// Extract entry date (after "on ")
let date = "";
const dateMatch = stored.match(/on\s*([\d-]+)/);
if (dateMatch) {
  date = dateMatch[1].trim();
}

// Reuse unified handler
handleWorkAuthChange(auth, date, entryVisa);

        setValue("resume", result.data?.resume)
        setFileName(result.data.resume)
        setValue("fileUrl", result.data.fileUrl)
        setFilepath(result.data?.fileUrl);
        setCandidatesID(result.data?.candidatesID)
        setValue("Comments",  sanitize(result.data?.comments))
        setValue("Priority",  sanitize(result.data?.priority))
            setValue("BillRate", sanitize1(result.data?.billRate));
      setValue("PayRate", sanitize1(result.data?.payRate));
        // setValue("BillRate",  sanitize(result.data?.billRate))
        // setValue("PayRate",  sanitize(result.data?.payRate))
        setValue("EmployerName",  sanitize(result.data?.employerName))
        setValue("SSN",  sanitize(result.data?.ssn))
        setValue("PassportNo",  sanitize(result.data?.passportNo))
        setValue("Certifications",  sanitize(result.data?.certifications))
        setValue("Tworefrencesfromrecentproject",  sanitize(result.data?.tworefrencesfromrecentproject))
        setValue("JobRole", sanitize(result.data?.jobRole))
        setValue("LinkedInUrl",  sanitize(result.data?.linkedInUrl))
          setValue("AvailabilityToInterview",sanitize( result.data?.availabilityToInterview))
          setValue("AvailabilityToJoin",sanitize( result.data?.availabilityToJoin))
           setValue("WillingToRelocate",sanitize( result.data?.willingToRelocate))
       
        setValue("VendorGuid", result.data?.vendorGuid)
        setValue("ClientStatus", sanitize( result.data?.clientStatus))
        setFileName(result.data.resume)
        setVisaCopyName(result.data.visaCopy)
        setDrivingLicenceName(result.data.drivingLicence)

        setMaskedResumeName(result.data.maskedResume)
      }).catch(

        function (error) {
          console.log("Error" + error)
        })
    setIsLoading(false);

  }
    const defaultStatusOptions = ["New", "Submitted"];

  const currentStatus = getValues("ClientStatus");
const statusOptions = defaultStatusOptions.includes(currentStatus)
  ? defaultStatusOptions
  : [...defaultStatusOptions, currentStatus];
  const FetchJobroles = async() => {
    const GetapiUrl =`${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
    const fetchJSON = async () => {
      const response = await fetch(GetapiUrl);
      let json = await response.json();
      SetJobRoles(json);
    }
    fetchJSON();
  }

  const fetchcoursesdata =async () => {
    const GetapiUrl = GetCourseInfo.APIURL;
    const fetchJSON = async () => {
      const response = await fetch(GetapiUrl);
      let json = await response.json();
      SetCourses(json);
    }
    fetchJSON();
  }
  
  function handleResumeChange(event) {
      const file = event.target.files[0];
      if (!file) return;
    
      const originalFileName = file.name;
    
      // Replace all characters except letters, numbers, dot, dash with underscore
      const sanitizedFileName = originalFileName.replace(/[^a-zA-Z0-9.\-_]/g, '_');
    
      // Allow only PDF, DOC, DOCX
      const allowedExtensions = /\.(pdf|doc|docx)$/i;
      if (!allowedExtensions.test(sanitizedFileName)) {
        Swal.fire({
          icon: 'error',
          text: 'Invalid file type. Only PDF, DOC, or DOCX allowed.',
        });
        event.target.value = '';
        setFile(null);
        setFileName('');
        return;
      }
    
      // Create a new File object with sanitized name
      const renamedFile = new File([file], sanitizedFileName, { type: file.type });
    
      setFile(renamedFile);
      setFileName(sanitizedFileName);
    }
  function handleMaskedResume(event) {
    const file = event.target.files[0];
    setMaskedResumeCopy(file)
     const originalFileName = file.name;
    
      // Replace all characters except letters, numbers, dot, dash with underscore
      const sanitizedFileName = originalFileName.replace(/[^a-zA-Z0-9.\-_]/g, '_');

    setMaskedResumeName(sanitizedFileName)
     var fileInput =document.getElementById('MaskedResume');
             
            var filePath = fileInput.value;
         
            // Allowing file type
            var allowedExtensions =
                    /(\.pdf|\.doc|\.docx)$/i;
             
            if (!allowedExtensions.exec(filePath)) {
              Swal.fire({
                text: 'Invalid File Type!',
                  })
               // toast.error('Issue with data format', {autoClose:500})
               
                fileInput.value = '';
                return false;
            }
            else
            { 
             
              return true;
            } 
  }

  function handleVisaCopy(event) {
    const file = event.target.files[0];
    setVisaCopy(file)
      const originalFileName = file.name;
    
      // Replace all characters except letters, numbers, dot, dash with underscore
      const sanitizedFileName = originalFileName.replace(/[^a-zA-Z0-9.\-_]/g, '_');

    setVisaCopyName(sanitizedFileName)
    var fileInput = document.getElementById('visaCopy');

    var filePath = fileInput.value;

    // Allowing file type
    const allowedExtensions = /(\.pdf|\.doc|\.docx|\.jpg|\.jpeg)$/i;

    if (!allowedExtensions.exec(filePath)) {
      Swal.fire({
        text: 'Invalid File Type!',
      })
      // toast.error('Issue with data format', {autoClose:500})

      fileInput.value = '';
      return false;
    }
    else {

      return true;
    }
  }
  function handleDrivingLicence(event) {
    const file = event.target.files[0];

    setDrivingLicence(file)
      const originalFileName = file.name;
    
      // Replace all characters except letters, numbers, dot, dash with underscore
      const sanitizedFileName = originalFileName.replace(/[^a-zA-Z0-9.\-_]/g, '_');
    setDrivingLicenceName(sanitizedFileName)
    var fileInput = document.getElementById('drivingLicence');

    var filePath = fileInput.value;

    // Allowing file type
    const allowedExtensions = /(\.pdf|\.doc|\.docx|\.jpg|\.jpeg)$/i;

    if (!allowedExtensions.exec(filePath)) {
      Swal.fire({
        text: 'Invalid File Type!',
      })
      // toast.error('Issue with data format', {autoClose:500})

      fileInput.value = '';
      return false;
    }
    else {

      return true;
    }
  }
  const handleImageUpload = async (event) => {
    const file = event.target?.files[0];
    setPhotoURL(file);
    setimgFilepath(URL.createObjectURL(file));

    if (fileInputRef.current) {
      const filePath = fileInputRef.current.value;

      // Allowing file type
      const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;

      if (!allowedExtensions.exec(filePath)) {
        Swal.fire({
          text: 'Invalid File Type!',
        });
        fileInputRef.current.value = '';
        setimgFilepath('');
        return false;
      } else {
        setimgFilepath(URL.createObjectURL(file));
        return true;
      }
    }
  };
const saveCandidateAudio = async (candidateGuid, candidateName, audioFile,audioValue) => {
  const audioFormData = new FormData();
  audioFormData.append("Guid", candidateGuid || null);
  audioFormData.append("CandidateName", candidateName || null);
  audioFormData.append("Audio", audioFile);
  audioFormData.append("AudioUrl", audioFile.name);
  audioFormData.append("FileId", "");

  try {
    await Axios.post(SaveCandidateRecordedAudio.APIURL, audioFormData, {
      headers: { "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`
       },
    });
  } catch (error) {
    console.error("Audio upload failed", error);
  }
};
// Mapping of FormData field names → candidateDetails keys
const fieldKeyMap = {
  Resume: "resume",
  FileUrl: "fileUrl",
  VisaCopy: "visaCopy",
  VisaCopyUrl: "visaCopyUrl",
  DrivingLicence: "drivingLicence",
  DrivingLicenceUrl: "drivingLicenceUrl",
  Passport: "passport",
  PassportURL: "passportURL",
  I94: "i94",
  I94File: "i94File",
  RTR_PDF: "rtR_PDF",
  RTR_PDFDoc: "rtR_PDFDoc",
  Resume_Insights_Pdf: "resume_Insights_Pdf",
  Resume_Insights_Pdfdoc: "resume_Insights_Pdfdoc",
  Others: "others",
  OthersDoc: "othersDoc"
};

const appendFileField = (formData, fieldName, urlField, uploadedFiles, previousData) => {
  const file = uploadedFiles?.[urlField];

  // CASE 1: User deleted file
  if (file === null) {
    formData.append(fieldName, null);
    formData.append(urlField, null);
    return;
  }

  // CASE 2: User uploaded a new file
  if (file instanceof File) {
    formData.append(fieldName, file.name);
    formData.append(urlField, file);
    return;
  }

  // CASE 3: User didn’t change → keep previous values
  const prevNameKey = fieldKeyMap[fieldName];
  const prevUrlKey = fieldKeyMap[urlField];

  const prevNameRaw = previousData?.[prevNameKey];
  const prevUrlRaw = previousData?.[prevUrlKey];

  const prevName = prevNameRaw && prevNameRaw !== "null" ? prevNameRaw : null;
  const prevUrl = prevUrlRaw && prevUrlRaw !== "null" ? prevUrlRaw : null;

  formData.append(fieldName, prevName);
  formData.append(urlField, prevUrl);
};

  const onSubmit = (data, e) => {
    e.preventDefault();
    Updatedata(data)
  }

  const Updatedata = async (data) => {
    if (!uploadedFiles.FileUrl) {
        Swal.fire({
          icon: "error",
          title: "Resume is required",
          text: "Please upload a Resume before submitting",
        });
              return;
            }
                setIsLoading(true);
    const formData = new FormData();
    const response = await fetch(defaultimg);
    const imageBlob = await response.blob();
     const address =`${selectedState} - ${selectedCity}`
    formData.append('Guid', queryguid);
    formData.append('UserGuid', Guid);
      formData.append('ProfileSummery', data.ProfileSummery);
      formData.append('Gender', data.gender);
      formData.append('PreferLocation', selectedCountry);
      formData.append("CountryID", selectedCountry);
      formData.append('MaritalStatus', data.maritalStatus);
    //  formData.append('ConsultantID',consultantDet[0].consultantID);
      formData.append('QualificationID', data.QualificationID);
      formData.append('Experience', data.experience);
      formData.append('MobileNumber', data.mobileNumber);
      formData.append('CurrentRole', "string");
appendFileField(formData, "Resume", "FileUrl", uploadedFiles, candidateDetails);
appendFileField(formData, "VisaCopy", "VisaCopyUrl", uploadedFiles, candidateDetails);
appendFileField(formData, "DrivingLicence", "DrivingLicenceUrl", uploadedFiles, candidateDetails);
appendFileField(formData, "Passport", "PassportURL", uploadedFiles, candidateDetails);
appendFileField(formData, "I94", "I94File", uploadedFiles, candidateDetails);
appendFileField(formData, "RTR_PDF", "RTR_PDFDoc", uploadedFiles, candidateDetails);
appendFileField(formData, "Resume_Insights_Pdf", "Resume_Insights_Pdfdoc", uploadedFiles, candidateDetails);
appendFileField(formData, "Others", "OthersDoc", uploadedFiles, candidateDetails);

   formData.append('HighestEducation', data.HighestEducation);
      formData.append ('Photo', data.photo);
      formData.append('PhotoURL', photoURL?photoURL:imgfilepath);
      formData.append('WorkMode', data.workMode);
      formData.append('TechnicalSkill', data.technicalSkill);
      formData.append('Address', data.address);
      formData.append('DOB', data.dob);
      formData.append('FullName', data.fullName);
      formData.append('Email', data.email);
           formData.append(
  "PayRate",
  data.PayRate
    ? selectedCountry == 2
      ? `$${data.PayRate}`
      : `Rs.${data.PayRate}`
    : ""
);


formData.append(
  "BillRate",
  data.BillRate
    ? selectedCountry == 2
      ? `$${data.BillRate}`
      : `Rs.${data.BillRate}`
    : ""
);
      // formData.append('BillRate', data.BillRate);
      // formData.append('PayRate', data.PayRate);
      formData.append('CustomAssessmentLink',data.customAssessmentLink)
      formData.append('SkillMetrics',data.SkillMetrics)
      formData.append('WorkAuthorizationandValidity', data.WorkAuthorizationandValidity);
      formData.append('EmployerName', data.EmployerName);
      formData.append('SSN', data.SSN);
      formData.append('PassportNo',data.PassportNo);
      formData.append('Tworefrencesfromrecentproject', data.Tworefrencesfromrecentproject);
      formData.append('Certifications', data.Certifications);
      formData.append('Comments', data.Comments);
      formData.append('Priority', data.Priority);
      formData.append('JobRole', data.JobRole);
      // formData.append('VisaCopy', data.VisaCopy);
      // formData.append('VisaCopyUrl', visaCopy);
      formData.append('MaskedResume', data.MaskedResume);
      formData.append('MaskedFileUrl', maskedResumeCopy);
      // formData.append('DrivingLicence', data.DrivingLicence);
      // formData.append('DrivingLicenceUrl', drivingLicence);
      formData.append('LinkedInUrl', data.LinkedInUrl);
      formData.append('clientStatus', data.clientStatus || "New");
      formData.append('CandidateType', data.CandidateType);
      formData.append('JobTitleID', data.jobPost ? data.jobPost?.value : "");
       formData.append('AvailabilityToInterview', data.AvailabilityToInterview);
      formData.append('AvailabilityToJoin', data.AvailabilityToJoin);
      formData.append('WillingToRelocate', data.WillingToRelocate);
      formData.append('CreatedBy', email);
      formData.append('SubmittedBy', email);
    console.log(typeof data.VendorGuid)
    if (data.VendorGuid) {
      formData.append('VendorGuid', data.VendorGuid);
    } else {
      formData.append('VendorGuid', "");
    }
    
    formData.append('UpdatedBy', email);
    const apiAddUrl = ReplicateBenchCandidatesProfileAPI.APIURL;
    Axios.post(apiAddUrl, formData,
      { headers: 
        { "Content-Type": "multipart/form-data",
           "Authorization": `Bearer ${token}`
       } }
    )
      .then(async (result) => {
        setIsLoading(false)
        if (result.data.message ===
          "Record created successfully") {
          //alert("created");
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Replicated Successfully ',
            showConfirmButton: false,
            timer: 5000
          })
               if (assessmentMode === "file" && assessmentFile) {
                await saveCandidateAudio(queryguid, data.fullName, assessmentFile,audioValue);
              }
          navigate("/Employer/GetCandidatesByEmployerUserID")
          // setIsDisabled(!isDisabled);
          // toast.success('Data Saving', {autoClose:5000})
        }
        else if (result.data.message === " Input data having some issues") {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Not updated',
            showConfirmButton: false,
            timer: 7000
          })

          // toast.error('Issue with data format', {autoClose:5000})
        }

      })
      .catch(() => {
        setIsLoading(false)
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Something went wrong try again',
          showConfirmButton: false,
          timer: 7000
        })
      })
  }
  const fetchcodocumenttypes=()=>
    {
      const GetapiUrl=GetDocumentTypes.APIURL;
      const fetchJSON = async () => {
        const response = await fetch(GetapiUrl);
        let json = await response.json();
        SetDocuments(json);
      }
      fetchJSON();
  }

        const jobTitleOptions = jobPosts.map(job => ({
        value: job.jobPostID,
        label: `${job.title} - ${job.clientName}`,
        jobDescription: job.jobDescription, // Store job description for later use
        billRate: job.billRate
      }));
         const handleChange = (index, field, value) => {
    const updated = [...skills];
    updated[index][field] = value;
    setSkills(updated);
    setValue("SkillMetrics", JSON.stringify(updated)); // keep hidden input updated
  };

  // Add new row
  const handleAdd = () => {
    const updated = [...skills, { Skill: "", YearsOfExp: "", Rating: "" }];
    setSkills(updated);
    setValue("SkillMetrics", JSON.stringify(updated));
  };

  // Delete row
  const handleDelete = (index) => {
    const updated = skills.filter((_, i) => i !== index);
    setSkills(updated);
    setValue("SkillMetrics", JSON.stringify(updated));
  };
const [selectedState, setSelectedState] = useState("");
const [selectedCity, setSelectedCity] = useState( );
const [cities, setCities] = useState([]);

const handleStateChange = (stateValue) => {
  let cityList = [];

  if (selectedCountry == 1) {
    cityList = IndiaStateCities[stateValue] || [];
  } else {
    cityList = usStateCities[stateValue] || [];
  }

  setSelectedState(stateValue);   // ✅ important
  setCities(cityList);
  setSelectedCity("");            // ✅ reset on change
};
  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchcoursesdata();
        await FetchJobroles();
        await fetchcountries();
        await GetVendorsList();
        await GetCandidateDetailsById();
        await fetchcodocumenttypes();

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [selectedCountry]);

  return (
    <ConsultantLayout>
      <section>
        {
          isLoading ? <center> <LoadingSpinner /> </center> :
            <div className="container-fluid mt-4 pb-5">
              <CandidateLayout title="Replicate Candidate" candidateGuid={queryguid} fullName= {candidateDetails?.fullName} email={candidateDetails?.email} />
              <hr />
              <div className="bg-gray mt-4">

                <form onSubmit={handleSubmit(onSubmit)}>

                  <div class="row p-3">
                    <div className="col-sm-12 col-lg-2 col-xl-2 col-md-2">

                      <div className="upload-btn-wrapper text-center">

                        <label htmlFor="photo" style={{ cursor: 'pointer' }}>
                          <img src={(photoURL==null) || (photoURL=="null")? defaultimg : imgfilepath}
                            alt="Upload Image" style={{
                              cursor: "pointer", borderRadius: '50%',
                              width: '100px',
                              height: '100px',
                            }} />
                             {/* <img src={ defaultimg}
                            alt="Upload Image" style={{
                              cursor: "pointer", borderRadius: '50%',
                              width: '100px',
                              height: '100px',
                            }} /> */}
                          <input
                            type="file"
                            id="photo"
                            style={{ display: 'none' }}
                            {...register('photo', { onChange: handleImageUpload })}
                          />
                        </label>
                </div>
                    </div>
                    <div className="col-sm-12 col-xl-5 col-lg-5 col-md-5">
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>
                        <input type="text" title='' placeholder='Full Name' {...register("fullName", { required: "Fullname Required" })} id="fullName" name="fullName"
                          disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.fullName ? 'is-invalid' : ''}`}
                        />
                      </OverlayTrigger>
                      <div className="invalid-feedback"> {errors.fullName?.message}</div>

                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>

                        <input
                          placeholder='Mobile Number'
                          type=""
                          min="0"
                          title=''
                          name="mobileNumber"
                          disabled={isDisabled}
                          {...register("mobileNumber", { required: "Mobile Number Required" })}
                          className={`form-control basic-form mt-3 ${errors.mobileNumber ? 'is-invalid' : ''}`}
                        />
                      </OverlayTrigger>
                      <div className="invalid-feedback"> {errors.mobileNumber?.message}</div>

                     
                      <div class="mb-2 mt-4" style={{fontSize:12, color:"#495057" }}>
          <label >Gender</label>

          </div>
          <input 
        {...register("gender", { required: true })}
        type="radio"
        name="gender"
        value="Male"
        id="field-male"
        disabled={isDisabled}
           className="mr-2"
      /> 
      <label style={{ fontSize: 13, color: "#495057" }}    className="mr-2">Male</label>
      
      <input  
        {...register("gender", { required: true })}
        type="radio"
        name="gender"
        value="Female"
        id="field-female"
        disabled={isDisabled}
      />
      <label style={{ fontSize: 13, color: "#495057", marginLeft: 10 }}>Female</label>
      
      {errors.gender && <div style={{color:"#dc3545",fontSize:"80%"}}>Gender required</div>}


           

                      <div class="mb-2 mt-4" style={{ fontSize: 12, color: "#495057" }}>
                        <lable >Marital Status</lable>
                      </div>
                      <input
                        {...register("maritalStatus")}
                        type="radio"
                        name="maritalStatus"
                        title='maritalStatus'
                        value="married"
                        id="maritalStatus"
                        disabled={isDisabled}
                        className="mr-2"

                      /><label style={{ fontSize: 13, color: "#495057" }}>Married</label>
                      &nbsp;&nbsp;
                      <input
                        {...register("maritalStatus")}
                        type="radio"
                        name="maritalStatus"
                        title='maritalStatus'
                        value="unmarried"
                        id="field-female"

                        disabled={isDisabled}
                      /><label style={{ fontSize: 13, color: "#495057", marginLeft: 10 }}>Unmarried</label>

                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Education</Tooltip>)}>

                        <select  {...register("QualificationID", { required: "Education Required" })} className={`form-control basic-form mt-3 ${errors.QualificationID ? 'is-invalid' : ''}`} style={{ height: 50, borderRadius: 15 }} >
                          <option value="">Select Education</option>
                          {
                            Courses.map((item, index) => {
                              return (

                                <option key={index} value={item.qualificationID}>{item.courseName}</option>

                              );
                            }

                            )
                          }
                        </select>
                      </OverlayTrigger>
                      <div className="invalid-feedback"> {errors.QualificationID?.message}</div>
                     <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Highest Education</Tooltip>)}>  
                      <input type="text" title='' placeholder='Highest Education' {...register("HighestEducation")} id="HighestEducation" name="HighestEducation" 
                      disabled={isDisabled} className={`form-control basic-form mt-3`}
                                  />
                    </OverlayTrigger>
                      {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Upload Resume (Filename should not contain spaces or special characters)</Tooltip>)}>

                        <input style={{ height: 38 }}   {...register("resume", { required: !fileName ? "resume Required" : false })}
                        name="resume" id="resume" type="file" className={`form-control mt-3  ${!fileName?errors.resume ? 'is-invalid' : '':""}`} accept=".doc, .docx,.pdf"
                        onChange={handleResumeChange} />
                      </OverlayTrigger>
                      {fileName && <div style={{ fontSize: 13 }}> {fileName}</div>}
                      <br /> */}


                     {fileName== null && <div className="invalid-feedback">{errors.resume?.message}</div>}

                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> BillRate</Tooltip>)}>
                        <input  type={selectedCountry == 2 ? "number" : "text"} title='' placeholder='Bill Rate' {...register("BillRate")} id="BillRate" name="BillRate"
                       className={`form-control basic-form mt-3`}
                        />
                      </OverlayTrigger>
                      <div className="invalid-feedback"> {errors.BillRate?.message}</div>
                         <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Pay Rate</Tooltip>)}> 
      <input  type={selectedCountry == 2 ? "number" : "text"} name="PayRate" {...register("PayRate")} placeholder="Pay Rate " className={`form-control basic-form mt-3`} />
      </OverlayTrigger>
                      <div className="invalid-feedback"> {errors.PayRate?.message}</div>
        {selectedCountry == 2 && (
  <div className="d-flex gap-2 mt-3">

    {/* Current Visa */}
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id="tooltip-workauth">Current Visa</Tooltip>}
    >
      <select
        className="form-control"
        style={{ height: 50 }}
        value={workAuth}
        onChange={(e) => handleWorkAuthChange(e.target.value, entryDate, entryVisa)}
      >
        {sortOptions(workAuthOptions).map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </OverlayTrigger>

    {/* First US Entry Visa */}
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id="tooltip-entry-visa">First US Entry Visa Type</Tooltip>}
    >
      <select
        className="form-control"
        style={{ height: 50 }}
        value={entryVisa}
        onChange={(e) =>
          handleWorkAuthChange(workAuth, entryDate, e.target.value)
        }
      >
        {sortOptions(entryVisaOptions).map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </OverlayTrigger>

    {/* First US Entry Date */}
   <OverlayTrigger
  placement="bottom"
  overlay={<Tooltip id="tooltip-year">First US Entry Year</Tooltip>}
>
  <select
    className="form-control"
    style={{ height: "50px" }}
    value={entryDate}
    onChange={(e) => handleWorkAuthChange(workAuth, e.target.value, entryVisa)}
  >
    <option value="">Select Year</option>
    {Array.from({ length: new Date().getFullYear() - 1969 }, (_, i) => {
      const year = new Date().getFullYear() - i;
      return (
        <option key={year} value={year}>
          {year}
        </option>
      );
    })}
  </select>
</OverlayTrigger>

    <input
      type="hidden"
      {...register("WorkAuthorizationandValidity")}
    />
  </div>
)}         
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> EmployerName</Tooltip>)}>
                        <input type="text" title='' placeholder='Employer Name' {...register("EmployerName")} id="EmployerName" name="EmployerName"
                         className={`form-control basic-form mt-3`}
                        />
                      </OverlayTrigger>
                      {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> SSN</Tooltip>)}>

                        <input
                          placeholder='Enter SSN'
                          type="Number"
                          min="0"
                          title=''
                          name="SSN"
                          disabled={isDisabled}
                          {...register("SSN", { required: "SSN Required" })}
                          className={`form-control basic-form mt-3 ${errors.SSN ? 'is-invalid' : ''}`}

                        />
                      </OverlayTrigger> */}
                      <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> SSN</Tooltip>)}>    
   
   <input 
   placeholder='Enter last 4 digits of SSN'
   type="number"
   name="SSN"
   {...register("SSN", { 
     validate: value => {
       // Check if value is empty
       if (!value) return true;
       // Check if value is exactly 4 digits
       const valueStr = value.toString();
       if (valueStr.length !== 4) {
         return "SSN must be exactly 4 digits";
       }
       return true;
     }
   })}
   className={`form-control basic-form mt-3`}
   onInput={(e) => {
     if (e.target.value.length > 4) {
       e.target.value = e.target.value.slice(0, 4);
     }
   }}
 />
 </OverlayTrigger>
                      {/* <div className="invalid-feedback"> {errors.SSN?.message}</div> */}
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Passport Number</Tooltip>)}>
                        <input type="text" title='' placeholder='Passport Number' {...register("PassportNo")} id="PassportNo" name="PassportNo"
                         className={`form-control basic-form mt-3`}
                        />
                      </OverlayTrigger>
                      <div className="invalid-feedback"> {errors.PassportNo?.message}</div>

                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Certifications</Tooltip>)}>
                        <input type="text" title='' placeholder='Certifications' {...register("Certifications")} id="Certifications" name="Certifications"
                      className={`form-control basic-form mt-3 `}
                        />
                      </OverlayTrigger>
    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Job Role</Tooltip>)}>

                        <select  {...register("JobRole", { required: "Job Role Required" })} className={`form-control basic-form mt-3 ${errors.JobRole ? 'is-invalid' : ''}`} style={{ height: 50, borderRadius: 15 }} >
                          <option value="">Select Job Role</option>
                          {
                            jobRoles.map((item, index) => {
                              return (
                                <option key={index} value={item.jobRoleId}>{item.jobRole}</option>

                              );
                            }

                            )
                          }
                        </select>
                      </OverlayTrigger>
                      <div className="invalid-feedback"> {errors.JobRole?.message}</div>
                     
                      <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Select Client
</Tooltip>)}>
<select  {...register("VendorGuid")} className={`form-control basic-form mt-3`}style={{height:50 ,borderRadius:15}} >
<option value=""> Select Client</option>
{
  vendorData.map((item,index)=>
  {
    return(

   <option key={index}  value={item.vGuid}>{item.vendorName} - {item.vendorCompanyName}</option>

    );
  }
  
  )
}
</select>
</OverlayTrigger>
 <OverlayTrigger
      placement="bottom"
      overlay={(props) => <Tooltip id="tooltip" {...props}>Select Job Title</Tooltip>}
    >
      <div className="mt-4">
        <Controller
          name="jobPost"
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              options={jobTitleOptions}
              placeholder="Select Job Title"
              className={`basic-form ${errors.jobPost ? 'is-invalid' : ''}`}
              styles={{
                control: (provided) => ({
                  ...provided,
                  height: 50,
                  borderRadius: 15,
                  fontSize:12,
                  borderColor: errors.jobPost ? 'red' : provided.borderColor
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999, // Ensures dropdown appears above everything
                  position: "absolute" // Fixes layout issues
                })
              }}
             
          
              // Store the entire selected option object
              onChange={(selectedOption) => {
                field.onChange(selectedOption); // Save the full selected option
                setValue("JobTitleID", selectedOption.jobPostID); // Set job description
                const rate = selectedOption?.billRate;
                const normalizedRate = typeof rate === "string" ? rate.replace(/[^0-9.]/g, "") : (rate ?? "");
                setValue("BillRate", normalizedRate)
              }}
            //  value={jobPostOptions.find(option => option.value === field.value)}
            value={field.value}
    
            />
          )}
        />
        {/* {errors.jobPost && <div className="invalid-feedback d-block">{errors.jobPost.message}</div>} */}
      </div>
</OverlayTrigger>
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Select Candidate Type
    </Tooltip>)}>
    <select  {...register("CandidateType")} className={`form-control mt-3`}style={{height:50 ,borderRadius:15,fontSize:12}} >
    <option value="">Select Candidate Type</option>
    {
      candidateType.map((item,index)=>
      {
        return(
    
       <option key={index}  value={item.candidateTypeID}>{item.candidateTypeID}</option>
    
        );
      }
      
      )
    }
    </select>
</OverlayTrigger> 
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Candidate Status</Tooltip>)}>
<select  {...register("ClientStatus")} className={`form-control basic-form mt-3`}style={{height:50 ,borderRadius:15}} >
<option value="">Select Candidate Status</option>
{/* <option value="New">New</option>
<option value="Submitted">Submitted</option>
<option value="In-Progress">In-Progress</option>
<option value="Interview Scheduled">Interview Scheduled</option>
<option value="On Hold">On-Hold</option>
<option value="Selected">Selected</option>
<option value="Rejected">Rejected</option> */}
 {statusOptions.map((status, index) => (
      <option key={index} value={status}>
        {status}
      </option>
    ))}
</select>
</OverlayTrigger>    
<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">Custom Assessment Link</Tooltip>}>
  <input
    type="text"
    className="form-control mt-3"
    placeholder="Enter / Upload Custom Assessment"
    onClick={() => setShowAssessmentModal(true)}   // 👈 use onClick, not onFocus
   value={
  assessmentMode === "link"
    ? watch("customAssessmentLink")
    : assessmentMode === "file"
    ? (assessmentFile?.name || "")
    : audioFile || ""   // 👈 show saved link from DB
}

    readOnly  // 👈 prevents cursor/focus
  />
</OverlayTrigger>
<label className="mt-3" style={{ fontSize: "12px" }}>
  Skill Metrics
</label>
                        {skills.map((skill, index) => (
        <div key={index} className="d-flex gap-2 mb-2 align-items-center mt-2">
          {/* Skill */}
          <input
            type="text"
            className="form-control"
            placeholder="Skill"
            value={skill.Skill}
            onChange={(e) => handleChange(index, "Skill", e.target.value)}
          />

          {/* Years of Exp */}
          <input
            type="text"
            className="form-control"
            placeholder="No.of Years Exp"
            value={skill.YearsOfExp}
            onChange={(e) => handleChange(index, "YearsOfExp", e.target.value)}
          />

          {/* Rating */}
          <input
            type="number"
            className="form-control"
            placeholder="Rating (1-5)"
            min="1"
            max="5"
            value={skill.Rating}
            onChange={(e) => handleChange(index, "Rating", e.target.value)}
          />

          {/* Delete Button */}
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleDelete(index)}
          >
            <i className="fa fa-trash"></i>
          </button>

          {/* Add Button (only on last row) */}
          {index === skills.length - 1 && (
            <button
              type="button"
              className="btn btn-success"
              onClick={handleAdd}
            >
              <i className="fa fa-plus"></i>
            </button>
          )}
        </div>
      ))}

      {/* Hidden input for API */}
      <input type="hidden" {...register("SkillMetrics")} />    
                    </div>
   <div className="col-sm-12 col-xl-5 col-lg-5 col-md-5">
                  

                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Email</Tooltip>)}>
                        <input type="text" title='' placeholder='Email' id="email" name="email" {...register("email", { required: "Email Required" })}
                          disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.email ? 'is-invalid' : ''}`}

                        />
                      </OverlayTrigger>
                      <div className="invalid-feedback"> {errors.email?.message}</div>

                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Date of Birth</Tooltip>)}>
                        <input type="date"  name="dob" pattern="/^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/([0-9]{4})$/"
                          {...register("dob")} className={`form-control basic-form mt-3`} placeholder="Date of birth" aria-label="Username" />
                      </OverlayTrigger>
                      <div className="invalid-feedback"> {errors.dob?.message}</div>
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Profile Summary</Tooltip>)}>
                        <textarea  style={{height:100}} type="text" title='' placeholder='Profile Summary' {...register("ProfileSummery")} id="ProfileSummery" name="ProfileSummery"
                          disabled={isDisabled} className={`form-control basic-form mt-3 `}
                        />
                      </OverlayTrigger>
   <div className="d-flex gap-2 mt-3">
       {/* State Dropdown */}
      <select
  name="state"
  className="form-control mt-3"
  value={selectedState}
  onChange={(e) => {
    setSelectedState(e.target.value);
    handleStateChange(e.target.value);
  }}
>
       <option value="">Select State</option>
       {selectedCountry == 1
         ? IndiaStates.map((s) => (
             <option key={s.value} value={s.value}>
               {s.label}
             </option>
           ))
         : usStates.map((s) => (
             <option key={s.value} value={s.value}>
               {s.label}
             </option>
           ))}
     </select>
     
       {/* City Dropdown */}
      <select
  name="city"
  className="form-control mt-3"
  value={selectedCity}
  onChange={(e) => setSelectedCity(e.target.value)}
  disabled={cities.length === 0}
>
  <option value="">Select City</option>
  {cities
    .slice() // make a copy to avoid mutating state
    .sort((a, b) => a.localeCompare(b)) // sort alphabetically
    .map((city, i) => (
      <option key={i} value={city}>
        {city}
      </option>
    ))}
</select>
     
     </div>
 <input
  type="hidden"
  {...register("address")}
  value={`${selectedState} - ${selectedCity}`}
/>

             <div className="d-flex gap-2 mt-3">
  {/* Years Dropdown */}
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip-years">Years of Experience</Tooltip>}
  >
    <select
      className={`form-control ${errors.experience ? "is-invalid" : ""}`}
      style={{height:50}}
      value={years}
      onChange={(e) => handleExperienceChange(e.target.value, months)}
    >
      <option value="">Years</option>
      {[...Array(51).keys()].map((y) => (
        <option key={y} value={y}>{y}</option>
      ))}
    </select>
  </OverlayTrigger>

  {/* Months Dropdown */}
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip-months">Months of Experience</Tooltip>}
  >
    <select
      className={`form-control ${errors.experience ? "is-invalid" : ""}`}
      value={months}
      onChange={(e) => handleExperienceChange(years, e.target.value)}
     style={{height:50}}
    >
      <option value="">Months</option>
      {[...Array(12).keys()].map((m) => (
        <option key={m} value={m}>{m}</option>
      ))}
    </select>
  </OverlayTrigger>
</div>


      {/* Hidden field to actually store combined value */}
      <input
        type="hidden"
        {...register("experience", { required: "Experience Required" })}
      />

      <div className="invalid-feedback">{errors.experience?.message}</div>
            
               
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Key Skills</Tooltip>)}>
                        <div  >
                          <textarea style={{height:100}} type="text" title='' disabled={isDisabled} name="technicalSkill" {...register("technicalSkill", { required: "KeySkills Required" })} placeholder="Enter Key Skills " className={`form-control basic-form mt-3 ${errors.technicalSkill ? 'is-invalid' : ''}`} />

                        </div>
                      </OverlayTrigger>

                      <div className="invalid-feedback"> {errors.technicalSkill?.message}</div>

                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Work Mode</Tooltip>)}>

                        <select  {...register("workMode", { required: "Work Mode Required" })} className={`form-control basic-form mt-3 ${errors.workMode ? 'is-invalid' : ''}`} style={{ height: 50, borderRadius: 15 }}  >
                          <option value="">Select Work Mode </option>
                          {
                            workmode.map((item, index) => {
                              return (

                                <option key={index} value={item.statusName}>{item.statusName}</option>

                              );
                            }

                            )
                          }
                        </select>
                      </OverlayTrigger>
                      {<div className="invalid-feedback">{errors.workMode?.message}</div>}

                   

                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Comments</Tooltip>)}>
                        <input type="text" name="Comments" {...register("Comments")} placeholder="Comments"
                          className={`form-control basic-form mt-3`} />
                      </OverlayTrigger>
              

                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Priority</Tooltip>)}>
                        <input type="text" name="Priority" {...register("Priority")} value={1} placeholder="Priority "
                          className={`form-control basic-form mt-3 `} />
                      </OverlayTrigger>
                     
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Two References from Recent Project</Tooltip>)}>
                        <input type="text" title='' placeholder='Two References from Recent Project' {...register("Tworefrencesfromrecentproject")} id="Tworefrencesfromrecentproject" name="Tworefrencesfromrecentproject"
                          disabled={isDisabled} className={`form-control basic-form mt-3 `}
                        />
                      </OverlayTrigger>
                  
                      <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>LinkedIn Url</Tooltip>)}>  
          <input type="text" title='' placeholder='LinkedIn Url' {...register("LinkedInUrl")} id="LinkedInUrl" name="LinkedInUrl" 
           className={`form-control basic-form mt-3 `}/>
        </OverlayTrigger>
        <div class="mb-2 mt-4" style={{fontSize:12, color:"#495057"}}>
              <lable >Willing to Relocate</lable>
              </div>
          <input
  {...register("WillingToRelocate")}
  type="radio"
  name="WillingToRelocate"  // ✅ Correct
  value="Yes"
  id="WillingToRelocate"
  disabled={isDisabled}
  className="mr-2"
/>
<label style={{ fontSize: 13, color: "#495057" }}>Yes</label>

&nbsp;&nbsp;

<input
  {...register("WillingToRelocate")}
  type="radio"
  name="WillingToRelocate"  // ✅ Correct
  value="No"
  id="WillingToRelocateNo"
  disabled={isDisabled}
/>
<label style={{fontSize : 13, color:"#495057", marginLeft : 10}}>No</label>
    
        
                             <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Availability to Interview</Tooltip>)}>  
                      <input type="text" title='' placeholder='Availability to Interview' {...register("AvailabilityToInterview")} id="AvailabilityToInterview" name="AvailabilityToInterview" 
                       className={`form-control basic-form mt-3 `}/>
                    </OverlayTrigger> 
                    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Availability for Joining</Tooltip>)}>  
                      <input type="text" title='' placeholder='Availability for Joining' {...register("AvailabilityToJoin")} id="AvailabilityToJoin" name="AvailabilityToJoin" 
                       className={`form-control basic-form mt-3 `}/>
                    </OverlayTrigger>       
       <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Upload Documents
       </Tooltip>)}>
       <select 
         onChange={(e) => {
           setSelectedDocType(e.target.value);
       
           handleShowModal(e.target.value);  // open modal
            e.target.value ="";
         }}
       className={`form-control mt-3 `}style={{height:50 ,borderRadius:15,fontSize:12}} >
       <option value="">Select Any Document</option>
       {
       
         documents.map((item,index)=>
         {
           return(
       
          <option key={index}  value={item.documentType}>{item.documentType}</option>
       
           );
         }
         
         )
       }
       </select>
                            </OverlayTrigger>
                           
     <div>
{Object.keys(uploadedFiles).map((docTypeKey) => {
  const file = uploadedFiles[docTypeKey];
  if (!file) return null;

  const isFileObject = file instanceof File;
  const isString = typeof file === "string";

  // ❌ Filter out invalid string values
  const isInvalidString =
    isString &&
    (
      file.trim() === "" ||
      file.trim().toLowerCase() === "null" ||
      file.trim().toLowerCase() === "undefined" ||
      file.endsWith("/") ||
      file.endsWith("/null") ||
      file.endsWith("/undefined")
    );

  // ⛔ skip invalid files completely
  if (isInvalidString) return null;

  const displayLabel = documentLabels[docTypeKey] || docTypeKey;
  const isValidUrl = isString && !isInvalidString;
  const fileName = isValidUrl ? file.split("/").pop() : file.name;
  const fileLink = isValidUrl ? file : URL.createObjectURL(file);

  return (
    <div key={docTypeKey}>
      <strong style={{ fontSize: 12 }}>{displayLabel} :</strong>&nbsp;
      <span style={{ fontSize: 12 }}>{fileName}</span>&nbsp;|&nbsp;
      <button
        type="button"
        style={{
          border: "none",
          background: "transparent",
          color: "blue",
          fontSize: 12,
          cursor: "pointer",
        }}
        onClick={() => handleShowModal1(docTypeKey, file)}
      >
        View
      </button>
      &nbsp; | &nbsp;
      <button
        type="button"
        style={{
          border: "none",
          background: "transparent",
          color: "red",
          fontSize: 12,
          cursor: "pointer",
        }}
        onClick={() => handleRemoveFile(docTypeKey)}
      >
        Remove
      </button>
    </div>
  );
})}

</div>

                    </div>
                  </div>
                  <div class="row mb-4 mt-3 ">
                    <div class="col-12">
                    <button 
                    type="button"
                     onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                     style={{ float: "right" }} disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                        Cancel
                      </button>
                      
                      <button id="svbutton" disabled={isSubmitting || isDisabled} className="btn btn-primary  mb-3 mr-3" style={{ float: "right" }}>
                        {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                        Save
                      </button> &nbsp;&nbsp;&nbsp;

                    </div>
                  </div>



                </form>

              </div>

            </div>

        }
           <Modal show={showModal} onHide={handleCloseModal}>
  <Modal.Header closeButton>
    <Modal.Title style={{color:"#00a7ac"}}>Upload {selectedDocType}</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{height:100}}>
    <input type="file" accept=".pdf,.jpg,.jpeg,.png,.docx" 

      style={{fontSize:18,color:"#00a7ac"}}
      onChange={(e) => {
        const file = e.target.files[0];
        if (!file) return;

        const originalFileName = file.name;
        // replace special characters
        const sanitizedFileName = originalFileName.replace(/[^a-zA-Z0-9.\-_]/g, "_");

        // allow only PDF, DOC, DOCX
        const allowedExtensions = /\.(pdf|doc|docx|jpg|jpeg|png|html)$/i;
        if (!allowedExtensions.test(sanitizedFileName)) {
          Swal.fire({
            icon: "error",
            text: "Invalid file type. Only PDF, DOC, or DOCX allowed.",
          });
          e.target.value = "";
          return;
        }

        // create new file with sanitized name
        const renamedFile = new File([file], sanitizedFileName, { type: file.type });

        let fileField = "";
        switch (selectedDocType) {
          case "Resume":
            fileField = "FileUrl";
            break;
          case "Visa Copy":
            fileField = "VisaCopyUrl";
            break;
          case "Driving Licence":
            fileField = "DrivingLicenceUrl";
            break;
          case "Passport":
            fileField = "PassportURL";
            break;
          case "I-94":
            fileField = "I94File";
            break;
                case "RTR_PDF":
            fileField = "RTR_PDFDoc";
            break;
             case "Resume_Insights_Pdf":
            fileField = "Resume_Insights_Pdfdoc";
            break;
             case "Others":
            fileField = "OthersDoc";
            break;
          default:
            fileField = `${selectedDocType}Url`;
        }

        setUploadedFiles((prev) => ({
          ...prev,
          [fileField]: renamedFile,
        }));

        handleCloseModal();
        setSelectedDocType("");
      }}
    />
  </Modal.Body>
</Modal>
<Modal show={showModal1} onHide={handleCloseModal1} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>{modalContent.title}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {renderAttachment(modalContent.url, modalContent.file, modalContent.html)}
  </Modal.Body>
</Modal>
<Modal show={showAssessmentModal} onHide={() => setShowAssessmentModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Custom Assessment Link</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {!assessmentMode && (
      <div className="d-flex flex-column gap-3">
        <button className="btn btn-outline-primary" onClick={() => setAssessmentMode("link")}>
          Enter Link Directly
        </button>
        <button className="btn btn-outline-secondary" onClick={() => setAssessmentMode("file")}>
          Upload File
        </button>
      </div>
    )}

    {assessmentMode === "link" && (
      <input
        type="text"
        className="form-control"
        placeholder="Enter Custom Assessment Link"
        {...register("customAssessmentLink")}
      />
    )}

    {assessmentMode === "file" && (
      <input
        type="file"
        accept="audio/*,.pdf,.doc,.docx,video/mp4,video/webm"
        className="form-control"
        onChange={(e) => setAssessmentFile(e.target.files[0])}
      />
    )}
  </Modal.Body>
  <Modal.Footer>
    <button className="btn btn-secondary" onClick={() => {
      setAssessmentMode("");
      setShowAssessmentModal(false);
    }}>
      Close
    </button>
    <button className="btn btn-primary" onClick={() => setShowAssessmentModal(false)}>
      Done
    </button>
  </Modal.Footer>
</Modal>
      </section>
    </ConsultantLayout>
  )
}
export default ReplicateBenchCandidatesProfile;